module.exports = __webpack_public_path__ + "static/media/grandPrize.5e666a18.png";